// @flow

export default (url: string, width: number): string => url.replace('__width__', width.toString());
